import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import './Tracking.js';
import './Sidebar.js';

(async () => {
    window.Alpine = Alpine;
    Alpine.plugin(collapse);

    await import('./Components/GeoContainer.js');

    Alpine.start();
})();